/** @jsxImportSource @emotion/react */
import React, { ReactNode } from 'react'

interface IProps {
  open: boolean
  setOpen: (open: boolean) => void
  children: ReactNode
}

export const Popover = ({ open, setOpen, children }: IProps) => {
  const popoverRef = React.useRef<HTMLDivElement | null>(null)

  React.useEffect(() => {
    const closeOnOutside = (event: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', closeOnOutside)
    return () => {
      document.removeEventListener('mousedown', closeOnOutside)
    }
  }, [])

  return (
    open && (
      <div
        ref={popoverRef}
        css={{
          position: 'absolute',
          background: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
          padding: '0.75rem',
          zIndex: 1000,
          width: 220,
          right: 20,
          top: '100%',
        }}
        onClick={(evt) => evt.stopPropagation()}>
        {children}
      </div>
    )
  )
}
